export default "__VITE_ASSET__CNHdtTZB__"